/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navsignin2Inputs */

const en_navsignin2 = /** @type {(inputs: Navsignin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const pt_navsignin2 = /** @type {(inputs: Navsignin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Navsignin2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const navsignin2 = /** @type {((inputs?: Navsignin2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navsignin2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_navsignin2(inputs)
	return pt_navsignin2(inputs)
});
export { navsignin2 as "navSignIn" }